import { getProfiles } from "../profiles/profiles.actions";
import { getIsWizardComplete } from "../wizard/wizard.selectors";

// TODO: Now this is not actually the initial load, we need to separate this part,
//  but we need to be careful because we need to have the profiles loaded
//  after service activation and saving profiles (on finish wizard)
//  That's why we still need this initial action in wizardGuard

export const getInitialData = () => (dispatch, getState) => {
  if (!getIsWizardComplete(getState())) return;

  dispatch({ type: INITIAL_LOAD });

  return dispatch(getProfiles())
    .then(() => dispatch(initialLoadSuccess()))
    .catch((error) => {
      dispatch(initialLoadFailure(error));
      return Promise.reject(error);
    });
};

export const INITIAL_LOAD = "[AUTH] INITIAL_LOAD";
export const INITIAL_LOAD_SUCCESS = "[AUTH] INITIAL_LOAD_SUCCESS";
export const initialLoadSuccess = (info) => ({
  type: INITIAL_LOAD_SUCCESS,
  payload: info,
});

export const INITIAL_LOAD_FAILURE = "[AUTH] INITIAL_LOAD_FAILURE";
export const initialLoadFailure = (info) => ({
  type: INITIAL_LOAD_FAILURE,
  payload: info,
});
